import React from 'react'

function MinusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      {...props}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="2"
        d="M3 11h16"
      ></path>
    </svg>
  )
}

export default MinusIcon
